<template>
  <div>
    <LoadingWidget v-if="loading" />

    <transition name="fade">
      <SectionTemplate
        v-if="!loading && items.length"
        class="hotel-section"
        title="Pousadas"
      >
        <div class="mt-10 grid-list">
          <template v-for="(item, keyItems) in items">
            <HotelCard
              v-if="smOnly || (!smOnly && keyItems <= 2)"
              :key="keyItems"
              v-bind="item"
            />
          </template>
        </div>

        <div class="mt-10 text-center">
          <ButtonWidget :to="path">Veja todas as Pousadas</ButtonWidget>
        </div>
      </SectionTemplate>
    </transition>
  </div>
</template>

<script>
import LoadingWidget from "../widgets/LoadingWidget.vue";
import SectionTemplate from "../templates/SectionTemplate.vue";
import HotelCard from "../cards/HotelCard.vue";
import ButtonWidget from "../widgets/ButtonWidget.vue";
import { formatToURL } from "../../utils/formatToURL";

const _config = {
  mod: "hotel",
  path: "/pousadas",
};

export default {
  data: () => ({
    loading: true,
    path: _config.path,
    itemsPerPage: 4,
    items: [],
  }),
  created() {
    this.get();
  },
  computed: {
    smOnly() {
      return this.$vuetify.breakpoint.smOnly;
    },
  },
  methods: {
    get() {
      this.$rest(_config.mod)
        .get({
          params: {
            itemsPerPage: this.itemsPerPage,
          },
        })
        .then((data) => {
          this.items = data.map(({ id, img, title, price }) => ({
            img,
            title,
            price: parseFloat(price),
            to: `${this.path}/${formatToURL(title)}-${id}`,
          }));
        })
        .then(() => (this.loading = false));
    },
  },
  components: {
    SectionTemplate,
    HotelCard,
    LoadingWidget,
    ButtonWidget,
  },
};
</script>

<style lang="scss" scoped>
.hotel-section::v-deep {
  .title-widget {
    &:before,
    &:after {
      background-color: var(--v-warning-base);
    }
  }
}

.grid-list {
  display: grid;
  gap: 10px;
  grid-template-columns: repeat(3, 1fr);

  @media screen and (max-width: 960px) {
    grid-template-columns: 1fr 1fr;
  }

  @media screen and (max-width: 600px) {
    grid-template-columns: 1fr;
  }
}
</style>
